'use client';

import type { ReactNode } from 'react';

import { Button } from '@/app/components/button';
import { IconChevronLeft } from '@/app/components/icons/ui-actions/icon-chevron-left';
import { IconClose } from '@/app/components/icons/ui-actions/icon-close';
import { ContainerStyled } from '@/app/components/layouts/container';
import { TopNavigationLogo } from '@/app/components/layouts/top-navigation/shared/logo';
import { TOP_NAV_DATA_GA } from '@/app/components/layouts/top-navigation/tracking';
import {
  TOP_NAV_HEIGHT_CLASSNAME,
  TOP_NAV_Z_CLASSNAME,
} from '@/app/constants/top-navigation';
import { cn } from '@/app/utils/cn';
import { createDataGA } from '@/app/utils/createDataGA';

interface MobileTopBarProps {
  logo?: ReactNode;
  className?: string;
  activeLabel?: string;
  onBack: () => void;
  onClose: () => void;
}

export const MobileTopBar = ({
  logo,
  className,
  activeLabel,
  onBack,
  onClose,
}: MobileTopBarProps) => {
  return (
    <nav
      className={cn(
        'flex items-center justify-between gap-x-2 border-b border-gray-50 bg-white',
        TOP_NAV_Z_CLASSNAME,
        TOP_NAV_HEIGHT_CLASSNAME,
        ContainerStyled({ size: 'mobile-only', maxWidth: 'none' }),
        className
      )}
    >
      {!!activeLabel ? (
        <Button
          variant="tertiary"
          color="red"
          size="sm"
          width="auto"
          iconBefore={<IconChevronLeft />}
          className="pl-0 text-left"
          onClick={onBack}
          {...createDataGA({
            click: true,
            eventName: TOP_NAV_DATA_GA.topNavigation,
            text: 'Mobile menu back',
          })}
        >
          {activeLabel}
        </Button>
      ) : (
        !!logo && <TopNavigationLogo logo={logo} />
      )}
      <Button
        variant="tertiary"
        color="black"
        iconBefore={<IconClose />}
        onClick={onClose}
        {...createDataGA({
          click: true,
          eventName: TOP_NAV_DATA_GA.topNavigation,
          text: 'Mobile menu close',
        })}
        className="shrink-0"
      />
    </nav>
  );
};
